import React from "react";
import PropTypes from "prop-types";
import Icon from "../../Common/Icon";

const Top = (props) => {
  const { children, formik, config } = props;

  let field1Name = "field1Name";
  let field2Name = "field2Name";
  try {
    field1Name = children[0].props.config.name;
  } catch (ex) {}
  try {
    field2Name = children[1].props.config.name;
  } catch (ex) {}

  return (
    <div className="reisplanner__row reisplanner__row--top">
      <div className="reisplanner__row-left">
        <div className="reisplanner__from">{children[0]}</div>
      </div>
      <div className="reisplanner__row-middle">
        <button
          type="button"
          className="reisplanner__switch-btn js-switch-animation"
          onClick={() => {
            const vanValue = formik.values[field1Name];
            const naarValue = formik.values[field2Name];

            formik.setFieldTouched(field1Name, true);
            formik.setFieldTouched(field2Name, true);
            formik.setFieldValue(field1Name, naarValue);
            formik.setFieldValue(field2Name, vanValue);
            formik.setFieldError(field1Name);
            formik.setFieldError(field2Name);
          }}
        >
          <Icon
            className="reisplanner__switch-icon"
            iconName="arrow-reverse"
            title={children[2].props.config.switchButtonLabel}
          />
        </button>
      </div>
      <div className="reisplanner__row-right">
        <div className="reisplanner__to">{children[1]}</div>
      </div>
    </div>
  );
};

Top.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
};

export default Top;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/ReisplannerTop.js